/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingCollectionLedger from './accounting-collection-ledger';
import AccountingCollectionLedgerDetail from './accounting-collection-ledger-detail';
import AccountingCollectionLedgerUpdate from './accounting-collection-ledger-update';
import AccountingCollectionLedgerDeleteDialog from './accounting-collection-ledger-delete-dialog';

const AccountingCollectionLedgerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingCollectionLedger />} />
    <Route path="new" element={<AccountingCollectionLedgerUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingCollectionLedgerDetail />} />
      <Route path="edit" element={<AccountingCollectionLedgerUpdate />} />
      <Route path="delete" element={<AccountingCollectionLedgerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingCollectionLedgerRoutes;
